import ar from './ar.json';
import en from './en.json';

/** Registered from `app.config.tsx` under the `legal` namespace — `shared/i18n` never imports a module (W2). */
export const legalCatalogs = { ar, en };
